import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store, { SESSION_ACTIVE_KEY } from './store'
import './assets/dashboard.css'
import { initAuthenticatedSession } from './services/sessionInit'
import { fetchProfile } from './services/auth'
import { updateAvailability } from './composables/useAvailability'
import { installN8nBurstFetchTap } from './utils/n8nBurstTiming'

// Fase 4 (reaberta) do plano de otimização de carregamento — só ativa o tap
// de fetch (pra rotular cada chamada de timing com o comando n8n real) se a
// flag de debug estiver ligada; precisa instalar o mais cedo possível, antes
// de qualquer chamada da sessão restaurada ou do login ao vivo.
try {
  if (localStorage.getItem('debug_n8n_timing') === '1') installN8nBurstFetchTap()
} catch { /* localStorage indisponível — segue sem o tap */ }

/**
 * sessionStorage sobrevive a um F5 mas é limpo pelo navegador ao fechar a
 * aba/janela — se existe usuário salvo no localStorage (persiste sempre) mas
 * a aba atual não tem o flag de sessão ativa, é porque o navegador/aba foi
 * fechado desde o último acesso: trata como logout em vez de restaurar.
 */
function checkStaleSession() {
  let raw: string | null = null
  try {
    raw = localStorage.getItem('auth_user')
    if (!raw || sessionStorage.getItem(SESSION_ACTIVE_KEY)) return false
  } catch { return false }

  try {
    const u = JSON.parse(raw)
    if (u?.access_token && u?.id) {
      updateAvailability(u.access_token, 'offline', u.id).catch(() => { /* melhor esforço */ })
    }
  } catch { /* usuário salvo corrompido — só limpa mesmo */ }

  localStorage.removeItem('auth_user')
  localStorage.removeItem('auth_team_ids')
  return true
}

async function bootstrap() {
  if (!checkStaleSession()) {
    store.dispatch('restoreSession')
  }
  const restoredUser = store.getters.authUser
  if (restoredUser) {
    // Fase 4.3 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
    // extraído pra services/sessionInit.ts — mesmo caminho que a Fase 4.4 vai
    // reaproveitar direto do login ao vivo, quando o reload sumir.
    await initAuthenticatedSession(restoredUser)
    // Atualiza message_signature em segundo plano — sessões antigas do localStorage
    // podem não ter esse campo, fazendo a assinatura não ser detectada nas mensagens.
    // Só relevante pra sessão restaurada a frio (aqui) — login ao vivo já busca
    // isso fresco (Fase 2, LoginView.vue), por isso não entrou em sessionInit.ts.
    fetchProfile(restoredUser.access_token)
      .then(profile => {
        store.commit('SET_USER', { ...store.getters.authUser, message_signature: profile.message_signature || '' })
      })
      .catch(_e => { /* silencioso — não bloqueia o startup */ })
  }
  createApp(App).use(store).use(router).mount('#app')
}

bootstrap()
